import { isNavigationRailSelected } from "../../NavigationRail.utils.js";
// import hooks
import { useState } from "react";
export const useNavigationRailSubItem = ({ id, label, tabIndex, onClick, onItemClick, submenu, selectedId, }) => {
    const selected = selectedId === id;
    const hasSubItems = !!submenu?.length;
    const subItemIsSelected = hasSubItems && submenu?.some((item) => isNavigationRailSelected(item, selectedId));
    const [collapseOpen, setCollapseOpen] = useState(subItemIsSelected);
    return {
        listItemButtonProps: {
            disablePadding: true,
            tabIndex,
            selected,
            disableRipple: true,
            disableTouchRipple: true,
            alignItems: "center",
            component: "div",
            onClick: () => {
                if (hasSubItems) {
                    setCollapseOpen((s) => !s);
                }
                else {
                    onClick?.();
                    onItemClick?.({ id, label });
                }
            },
        },
        selected,
        hasSubItems,
        collapseOpen,
        subItemIsSelected,
    };
};
export default useNavigationRailSubItem;
